module.exports = __webpack_public_path__ + "static/img/company6.22dae11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company6.png
// module id = N+IG
// module chunks = 1